import { styled } from "@mui/material/styles";
import { Button as MuiButton
} from "@mui/material";

export const SelectButtonContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.5rem",
  position: 'relative',
  zIndex: "1",
}));

export const CustomSelectButton = styled(MuiButton)(({ theme }) => ({
    minWidth: "5.875rem",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden",
    height: "3.25rem",
    borderRadius: "6.25rem",
    backgroundColor: theme.colors["neutral.900"],
    color: theme.colors.white,
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.medium,
    padding: `${theme.space._400} ${theme.space._500}`,
    textTransform: 'none',
    fontSize: theme.fontSizes.md,

    "&.selected": {
      color: theme.colors["neutral.950"]
    }
  }));